import React, { lazy } from 'react';
export const BookDetails = () => {
  return <div className="py-16 bg-white relative" data-id="element-8">
      {/* Patriotic corner element */}
      <div className="absolute bottom-0 left-0 w-16 h-16 md:w-24 md:h-24 opacity-30" data-id="element-9">
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full text-blue-700" data-id="element-10">
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-11" />
        </svg>
      </div>
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-12">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 flex items-center" data-id="element-13">
          <span className="text-red-700 mr-2" data-id="element-14">★</span>
          Inside the book you'll discover…
        </h2>
        <ul className="list-disc pl-6 space-y-4 text-lg text-gray-700 mb-12" data-id="element-15">
          <li data-id="element-16">
            Charlie's complete journey: from Illinois kid to national voice for
            American values.
          </li>
          <li data-id="element-17">
            Over 100 quotes, organized by theme—freedom, faith, patriotism,
            leadership, politics, motivation.
          </li>
          <li data-id="element-18">
            The exact strategies he used to build one of the most influential
            conservative student movements in America.
          </li>
          <li data-id="element-19">
            The controversies and criticisms that made him impossible to ignore
            in the battle for America's future.
          </li>
        </ul>
        <div className="bg-blue-50 border-l-4 border-blue-700 p-6 mb-12 relative overflow-hidden" data-id="element-20">
          <div className="absolute top-0 right-0 w-16 h-16 opacity-10" data-id="element-21">
            <div className="w-full h-1/3 bg-red-700" data-id="element-22"></div>
            <div className="w-full h-1/3 bg-white" data-id="element-23"></div>
            <div className="w-full h-1/3 bg-blue-700" data-id="element-24"></div>
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-25">
            Why this matters now
          </h3>
          <p className="text-lg text-gray-700" data-id="element-26">
            Whether you agree with him or not, Charlie Kirk changed the
            landscape of youth politics and reignited patriotic values among a
            new generation. To understand today's cultural battles for America's
            soul, you need to understand him.
          </p>
          <p className="text-lg text-gray-700 mt-4" data-id="element-27">
            And for the first time, his words, story, and legacy are available
            in one place.
          </p>
        </div>
        <div className="flex justify-center my-12 relative" data-id="element-28">
          <div className="absolute inset-0 rounded-lg border-2 border-transparent bg-gradient-to-br from-red-700/20 via-transparent to-blue-700/20" data-id="element-29"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xbgaUfJSyGPH6EvPaWDh9H/Gemini_Generated_Image_1miczc1miczc1mic.png" alt="Charlie Kirk book signing event at library" className="w-full max-w-2xl rounded-lg shadow-lg relative z-10" loading="lazy" width="600" height="400" data-id="element-30" />
        </div>
      </div>
    </div>;
};